import * as React from 'react'
import { useForm } from 'react-hook-form'

import { AuthHeading } from '../../components/authentication/auth-heading'
import { Button } from '../../components/button'
import { FormGroup } from '../../components/form-group'
import { Input } from '../../components/input'
import { Intent } from '../../config/intent'
import { authService } from '../../lib/auth-service'
import { Validation } from '../../lib/validation'

export const TestId = {
    FORM: 'reset-password-request-form',
}

export const I18n = {
    HEADING: 'Reset your password',
    SUB_HEADING: 'Reset your password to access your account',
    EMAIL_LABEL: 'Registered email address*',
    SUBMIT: 'Reset password',
    NO_USER: 'No user for that email',
}

interface RequestFormValues {
    email: string
}

interface RequestStepProps {
    onComplete: (data: RequestFormValues, response: any) => void
}

export function RequestStep({ onComplete }: RequestStepProps) {
    const [formError, setFormError] = React.useState('')
    const [loading, setLoading] = React.useState(false)

    const {
        register,
        handleSubmit,
        formState: { errors },
        setError,
    } = useForm<RequestFormValues>()

    function handleError(err: any) {
        if (err.code === 'InvalidParameterException') {
            setError('email', { message: I18n.NO_USER })
        } else {
            setFormError(err.message)
        }
    }

    async function onSubmit(data: RequestFormValues) {
        setLoading(true)
        try {
            const res = await authService.resetPassword(data)
            onComplete(data, res)
        } catch (err) {
            handleError(err)
            setLoading(false)
        }
    }

    return (
        <React.Fragment>
            <AuthHeading heading={I18n.HEADING} subHeading={I18n.SUB_HEADING} />
            <form onSubmit={handleSubmit(onSubmit)} data-testid={TestId.FORM}>
                <FormGroup
                    label={I18n.EMAIL_LABEL}
                    htmlFor='email'
                    intent={
                        errors.email?.message ? Intent.DANGER : Intent.DEFAULT
                    }
                    message={errors.email?.message}>
                    <Input
                        intent={
                            errors.email?.message
                                ? Intent.DANGER
                                : Intent.DEFAULT
                        }
                        id='email'
                        {...register('email', Validation.email)}
                    />
                </FormGroup>
                <Button
                    loading={loading}
                    disabled={loading}
                    fill={true}
                    type='submit'
                    size='large'
                    className='mb-10'>
                    {I18n.SUBMIT}
                </Button>
                {formError && (
                    <p className='text-center text-danger'>{formError}</p>
                )}
            </form>
        </React.Fragment>
    )
}
